module.exports = __webpack_public_path__ + "static/fonts/AlibabaPuHuiTi-2-115-Black.987becdc.ttf";